"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordContentService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordContentService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordContentService.instance) {
      return CordContentService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordContentService.instance = this;
  }
  getAllContent() {
    return this.get('content');
  }
  getContentById(id) {
    return this.get(`content/${id}`);
  }
  createContent(item) {
    return this.post('content', item);
  }
  saveContent(item) {
    return this.patch(`content/${item.Id}`, item);
  }
  searchContent(data) {
    const result = this.post('Content/Search', data);
    return result;
  }
  getInteractionByContentId(contentId) {
    return this.get(`Content/Interactions/${contentId}`);
  }
  getInteractions() {
    return this.get(`Content/Interactions`);
  }
  createInteraction(contentId, data) {
    return this.post(`Content/Interactions/${contentId}`, data);
  }
  trackInteraction(contentId, data) {
    return this.patch(`Content/Interactions/Track/${contentId}`, data);
  }
  // Can only be used to update the HasAppInstalled.
  // To update other interaction use trackInteraction
  updateInteraction(contentId, data) {
    return this.patch(`Content/Interactions/${contentId}`, data);
  }
}
exports.CordContentService = CordContentService;
CordContentService.instance = null;
